import React, { useState } from 'react';
import Modal from '@/utils/modal.utils';
interface Ratings {
  overall: number;
  wealth_investments: number;
  career_profession: number;
  education: number;
  health: number;                                                    
  relationships: number;
  children: number;
}

interface Props {
  ratings: Ratings;
  custom?: boolean;
  disableClick?: boolean;
}

const LABELS: { key: keyof Ratings; label: string }[] = [
  { key: 'overall', label: 'Overall' },
  { key: 'wealth_investments', label: 'Wealth & Investments' },
  { key: 'career_profession', label: 'Career & Profession' },
  { key: 'education', label: 'Education' },
  { key: 'health', label: 'Health' },
  { key: 'relationships', label: 'Relationships' },
  { key: 'children', label: 'Children' },
];

const getColor = (rating: number) => {
  if (rating === 0) return 'bg-transparent';
  if (rating <= 4) return 'bg-red-400';
  if (rating <= 7) return 'bg-yellow-300';
  return 'bg-green-400';
};

const Y_AXIS = [10, 8, 6, 4, 2, 0];


const RatingsBarChart: React.FC<Props> = ({ ratings,custom,
  disableClick = false, }) => {
    const [modalOpen, setModalOpen] = useState(false);
 const chartHeightClass = custom
  ? 'h-[240px] sm:h-[280px] md:h-[300px] lg:h-[360px] xl:h-[375px]'
  : 'h-[240px] sm:h-[210px] md:h-[240px] lg:h-[260px] xl:h-[245px] 2xl:h-[340px]';

  return (
    <div className="w-full bg-white rounded-xl md:mb-10 md:mb-0">
      <h3 className="font-spectral text-[#001B6B] font-semibold text-[16px] md:text-[18px] uppercase mb-8 text-center">
       Your Ratings Overview
      </h3>

      <div className="flex">
        <div
          className={`flex flex-col justify-between pr-4 text-sm text-[#001B6B] font-semibold ${chartHeightClass}`}
        >
          {Y_AXIS.map((v) => (
            <span key={v}>{v}</span>
          ))}
        </div>

        <div className="flex-1 overflow-hidden">
          <div
            className={`relative border-l border-b border-black pl-6 ${chartHeightClass}`}
          >
            {Y_AXIS.map((v) => (
              <div
                key={v}
                className="absolute left-0 w-full border-t border-gray-300 border-dashed"
                style={{ bottom: `${(v / 10) * 100}%` }}
              />
            ))}

            <div className="absolute inset-0 grid items-end grid-cols-7 gap-2 px-4 md:gap-4">
              {LABELS.map(({ key, label }) => {
                const value = ratings[key];
                return (
                  <div key={key} className={`flex justify-center h-full ${
                      disableClick ? '' : 'cursor-pointer '
                    } transition-transform`}
                    onClick={() => {
                      if (!disableClick) setModalOpen(true);
                    }}>
                    <div
                      className={`relative w-[20px] sm:w-[40px] md:w-[44px] h-full rounded-t-xl border border-black overflow-hidden position-sticky ${chartHeightClass}`}

                    >
                      <div
                        className={`absolute bottom-0 left-0 w-full ${getColor(
                          value
                        )} transition-all duration-500`}
                        style={{ height: `${(value / 10) * 100}%` }}
                      />
                      <div className="absolute inset-0 flex items-end justify-center ">
                        <span className=" font-20 font-spectral font-semibold md:font-bold text-black -rotate-90  px-1 pl-[170px] sm:pl-[190px] lg:pl-[220px] whitespace-nowrap ">
                          {label}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
            {!disableClick && (
        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          title="Ratings Overview"
          widthClass="max-w-2xl"
        >
          <RatingsBarChart ratings={ratings} custom disableClick />
        </Modal>
      )}
    </div>
  );
};

export default RatingsBarChart;
